const MarketOpen = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="18" height="18" fill="none">
            <circle cx="9" cy="9" r="9" fill="#089981" fillOpacity="0.2" />
            <circle cx="9" cy="9" r="4" fill="#089981" />
        </svg>
    )
}
export default MarketOpen